import { useTableVariant } from '@work4all/components/lib/components/table/TableVariantProvider';

import { Entities } from '@work4all/models/lib/Enums/Entities.enum';

import { useErpHeader } from './ErpPageHeader';

/**
 * Would be aswesome if we can configure each common thing in single hook
 * f.e. move useErpHandlersTemplate or useCloneConvertTableErpActions
 */
export const useErpTable = (entity: Entities, disablePosition: boolean) => {
  const { variant } = useTableVariant();
  useErpHeader(entity, variant ? 'positions' : 'receipts', disablePosition);
};
